import React, { useEffect, useRef } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import { bind } from 'bind-event-listener';

export const ElementEventListener = ({
	handler,
	children,
}: {
	children: React.ReactNode;
	handler?: () => void;
}) => {
	const wrapperRef = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		if (!wrapperRef.current || !handler) {
			return;
		}

		const handleMouseDown = (e: MouseEvent) => {
			const isLink = (e.target as Element).closest('a');
			if (isLink && e.button !== 0) {
				handler();
			}
		};

		const unbind = bind(wrapperRef.current, {
			type: 'mousedown',
			listener: handleMouseDown,
		});

		return unbind;
	}, [handler]);

	return <span ref={wrapperRef}>{children}</span>;
};
